// extracted by mini-css-extract-plugin
export default {"red":"NotificationInfo_red__uEi5d"};